import React, { Component } from 'react';
import { Login } from '$components/auth';
import { login } from '$actions/accounts';
import { changeTitle } from '$actions/root';
import { formSelector } from '$selectors';
import { connect } from 'react-redux';
import {Translate} from "$common";

@connect(state => ({
  form: formSelector(state, 'login')
}), { login, changeTitle })
export default class LoginRoute extends Component {
  componentWillMount() {
    this.props.changeTitle(Translate.get('login'))
  }

  render() {
    const { form, login } = this.props;

    return (
      <Login
        errors={form.errors}
        onSubmit={login}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/login.js